// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","investmentPreferencesList":"_2c_L5xBVSEGav6tP9aFh4N"};